import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import StudentDashboard from './pages/StudentDashboard';
import AddCourse from './pages/AddCourse';
import AdminPanel from './pages/AdminPanel';
import Courses from './pages/Courses';
import Submissions from './pages/Submissions';
import ExaminerDashboard from './pages/ExaminerDashboard';
import ExaminerCourses from './pages/ExaminerCourses';
import ExaminerSubmissions from './pages/ExaminerSubmissions';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<StudentDashboard />} />
        <Route path="/addcourse" element={<AddCourse />} />
        <Route path="/adminpanel" element={<AdminPanel />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/submissions" element={<Submissions />} />
        <Route path="/exdashboard" element={<ExaminerDashboard />} />
        <Route path="/excourses" element={<ExaminerCourses />} />
        <Route path="/exsubmissions" element={<ExaminerSubmissions />} />

      </Routes>
    </Router>
  );
}

export default App;